import React, { useState } from "react";
// import AddAmountData from "../../components/pageComponents/UserDetailFormModel/UserAmount/AddAmountData";
// import UserUpdateAmount from "../../components/pageComponents/UserDetailFormModel/UserUpdateAmount";
import AddAmount from "../../components/pageComponents/UserDetailFormModel/UserAmount/AddAmount";
import { IoClose } from "react-icons/io5";
import SubtractAmount from "../../components/pageComponents/UserDetailFormModel/UserAmount/SubtractAmount";
import ScrollOff from "../../components/pageComponents/WindowScrollOff/ScrollOff";
// import Backdrop from "../Backdrop/Backdrop";

// import Model from "../model/Model";
function MasterDeleteModal({
  message,
  setMessage,
  Delete,
  content,
  storeAcceptID,
  Submited,
  SubmitWithAmountDisplay,
  getUserData,
  setStoreAcceptID,
  type,
}) {
  const [addMoney, setAddMoney] = useState(false);

  const handleNext = () => {
    setAddMoney(true);
  };

  return (
    <div>
      {addMoney && SubmitWithAmountDisplay && type === "Deposit" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-30">
          <div className="h-fit bg-white w-full max-w-md tablet:w-2/5 py-6 px-6 rounded-lg shadow-xl">
            <div className="flex items-center justify-between mb-5">
              <div className="text-lg font-semibold text-gray-800">Credit amount to user</div>
              <button
                className="p-1.5 text-white bg-red-500 hover:bg-red-600 rounded-full transition-colors"
                onClick={() => setAddMoney(false)}
              >
                <IoClose className="w-5 h-5" />
              </button>
            </div>
            <AddAmount
              addMoney={addMoney}
              getUserData={getUserData}
              SubmitWithAmountDisplay={SubmitWithAmountDisplay}
              setMessage={setMessage}
              storeAcceptID={storeAcceptID}
              setStoreAcceptID={setStoreAcceptID}
              type={type}
              setAddMoney={setAddMoney}
            />
          </div>
        </div>
      )}
      {addMoney && SubmitWithAmountDisplay && type === "withdrawal" && (
        <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black bg-opacity-30">
          <div className="h-fit bg-white w-full max-w-md tablet:w-2/5 py-6 px-6 rounded-lg shadow-xl">
            <div className="flex items-center justify-between mb-5">
              <div className="text-lg font-semibold text-gray-800">Debit amount from user</div>
              <button
                className="p-1.5 text-white bg-red-500 hover:bg-red-600 rounded-full transition-colors"
                onClick={() => setAddMoney(false)}
              >
                <IoClose className="w-5 h-5" />
              </button>
            </div>
            <SubtractAmount
              getUserData={getUserData}
              SubmitWithAmountDisplay={SubmitWithAmountDisplay}
              setMessage={setMessage}
              storeAcceptID={storeAcceptID}
              setStoreAcceptID={setStoreAcceptID}
              type={type}
              setAddMoney={setAddMoney}
            />
          </div>
        </div>
      )}
      <ScrollOff message={message}>
        <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
            <div className="py-4 text-gray-700 text-base">
              {content ? content : "Are you sure you want to delete this?"}
            </div>
            <div className="flex flex-row-reverse gap-3 pt-4">
              {content ? (
                <button
                  className="px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors"
                  onClick={() => SubmitWithAmountDisplay ? handleNext() : Submited()}
                >
                  {SubmitWithAmountDisplay ? "Next" : "Accept"}
                </button>
              ) : (
                <button
                  className="px-5 py-2.5 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
                  onClick={() => Delete()}
                >
                  Delete
                </button>
              )}
              <button
                className="px-5 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors"
                onClick={() => setMessage(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </ScrollOff>
    </div>
  );
}

export default MasterDeleteModal;
